var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FORM_ERROR } from 'final-form';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiAuthLogin, authRedirectReset } from '@/actions/AuthActionsTs';
import { LoginView } from '@/components/pages/login/LoginView';
import { hasRequiredParam } from '@/helpers/user/UserProfileHelper';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { UNAUTHORIZED_LOGIN } from '@/utils/constants/api/responseCode';
import { myPagePath } from '@/utils/router/links';
export const LoginPage = (props) => {
    const { redirectPath } = props;
    const dispatch = useDispatch();
    const history = useNavigate();
    /**
     * ログイン処理(LoginForm submit)
     */
    const login = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { email, password } = formValues;
        // FIXME: 型定義の関係上 apiAuthLogin を直接叩いてます
        // TODO: apiAuthLogin -> authLogin
        const response = yield wrapDispatch(dispatch, apiAuthLogin({ json: { email, password } }, {}));
        dispatch(authRedirectReset());
        // API側でリダイレクト先が指定されている場合はそちらを優先する
        if (typeof ((_b = (_a = response === null || response === void 0 ? void 0 : response.payload) === null || _a === void 0 ? void 0 : _a.customFields) === null || _b === void 0 ? void 0 : _b.redirect) === 'string') {
            history.push(response.payload.customFields.redirect);
            return;
        }
        // プロフィール上に必要な情報が入力されているか
        const hasRequiredParamState = hasRequiredParam(response.payload.auth, response.payload.profile);
        // 未入力のプロフィールがある場合、マイページに飛ばす
        if (!hasRequiredParamState) {
            history.push(myPagePath());
            return;
        }
        history.push(redirectPath);
    }), [dispatch, redirectPath, history]);
    /**
     * ログイン失敗時の処理
     * @param errorObject
     */
    const loginErrorCallback = useCallback(({ exception }) => {
        var _a, _b;
        const isLoginError = ((_b = (_a = exception === null || exception === void 0 ? void 0 : exception.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) === UNAUTHORIZED_LOGIN;
        return isLoginError
            ? {
                [FORM_ERROR]: 'メールアドレス、またはパスワードが正しくありません。',
            }
            : undefined;
    }, []);
    return _jsx(LoginView, { customErrorCallback: loginErrorCallback, onSubmit: login });
};
